<template>
	<div class="bokeh">
		<div
				v-for="n in currentLightsCount"
				:key="n"
				class="light"
		/>
	</div>
</template>

<script>
export default {
	name: 'ChristmasLoginBokeh',
	props: {
		// сколько огоньков на десктопе
		lightsDesktop: {
			type: Number,
			default: 150
		},
		// сколько огоньков на мобильных
		lightsMobile: {
			type: Number,
			default: 30
		},
		// ширина, ниже которой считаем устройство мобильным
		mobileBreakpoint: {
			type: Number,
			default: 768
		}
	},
	data() {
		return {
			isMobile: false
		};
	},
	computed: {
		currentLightsCount() {
			// гарантируем, что не вылезем за максимум, описанный в SCSS ($lights)
			const maxLights = 150;
			const target = this.isMobile ? this.lightsMobile : this.lightsDesktop;

			return Math.min(target, maxLights);
		}
	},
	mounted() {
		this.checkIsMobile();
		window.addEventListener('resize', this.checkIsMobile);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.checkIsMobile);
	},
	methods: {
		checkIsMobile() {
			if (typeof window === 'undefined') return;
			this.isMobile = window.innerWidth <= this.mobileBreakpoint;
		}
	}
};
</script>

<style lang="scss" scoped>
/* Colors */
$colorCollection: (
		#D00010,
		#FEC641,
		#63C13B,
		#FE0016,
		#5C6C94,
		#6B0D05,
		#7D0006,
		#DB1913,
		#FEE34A,
		#2F8A27
);

/* Config */
$lights: 150; // максимум, под который генерятся nth-child
$totalAnimation: 5;
$lightSize: 65;
$blurLevel: 8;

.bokeh {
	z-index: 1;
	position: absolute;
	width: 100%;
	height: 100%;
	pointer-events: none;
	top: 0;
	left: 0;
	overflow: hidden;
	opacity: 0.5;
}

.light {
	position: absolute;
	border-radius: 50%;
	opacity: 0;
}

// генерим параметры для каждого "огонька"
@for $i from 1 through $lights {
	$lightWidth:      $lightSize + random(25);
	$lightHeight:     $lightWidth;
	$lightVertical:   random(100);
	$lightHorizontal: random(100);
	$lightBlur:       $blurLevel + random($blurLevel);
	$lightDelay:      10 + random(25);
	$animation:       1 + random($totalAnimation);

	.light:nth-child(#{$i}) {
		width:  $lightWidth + px;
		height: $lightHeight + px;
		top:    #{$lightVertical + "%"};
		left:   #{$lightHorizontal + "%"};
		background: nth($colorCollection, random(length($colorCollection)));
		filter: blur($lightBlur + px);
		animation: #{$lightDelay + s} #{"light" + $animation} linear infinite;
	}
}

// анимации мерцания
@for $i from 1 through $totalAnimation {
	@keyframes light#{$i} {
		25% {
			opacity: (25 + random(50)) * 0.01;
		}
		50% {
			opacity: 0;
		}
		75% {
			opacity: (25 + random(50)) * 0.01;
		}
		100% {
			opacity: 0;
		}
	}
}
</style>
